module.exports = __webpack_public_path__ + "img/comments.fb3b3f3e.svg";